module.exports = __webpack_public_path__ + "static/media/mockup.d11c8efd.jpg";